import axios from "axios";
import API_BASE_URL from "../config";


const News_API = `${API_BASE_URL}/News`; // Replace with your actual API URL


// ✅ Add News API Call
export const addnews = async (newsData) => {
    try {
      const response = await axios.post(`${News_API}/save`, newsData, {
        headers: {
          Authorization: getAuthToken() ? `Bearer ${getAuthToken()}` : "", // ✅ Attach token if available
          "Content-Type": "application/json",
        },
      });
      return response.data; // ✅ Return response directly
    } catch (error) {
      console.error("AddNews Error:", error.response?.data || error.message);
      
      return { 
        Success: false, 
        Message: error.response?.data?.Message || "An error occurred during Addnews." 
      }; // ✅ Instead of throwing, return an object
    }
  };

  // ✅ Get Authenticated User
export const getAuthToken = () => {
  return localStorage.getItem("token"); // ✅ Fetch Token from Storage
};

  // ✅ Get Authenticated User
  export const getuserId = () => {
    return localStorage.getItem("userId"); // ✅ Fetch userid from Storage
  };

  export const getNews = async (newsData) => {
    try {  
      const response = await axios.post(`${News_API}/get`, newsData, );
  
      return response.data; // ✅ Return API response
    } catch (error) {
      console.error("Get News Error:", error);
      return { success: false, newsPagedResult: { data: [], totalRecords: 0 } };
    }
  };
  


export const getNewsById = async (id) => {
  try {
    const response = await axios.get(`${News_API}/details/${id}`,
    );
    return { success: true, newsData: response.data };
  } catch (error) {
    console.error("API error:", error);
    return { success: false };
  }
};

export const getNewsBySlug = async (slug) => {
  try {
    const response = await axios.get(`${News_API}/details/${slug}`,
    );
    return { success: true, newsData: response.data };
  } catch (error) {
    console.error("API error:", error);
    return { success: false };
  }
};

export const likeNews = async (newsId) => {
  try {
    const response = await axios.post(`${News_API}/like`, { Id: newsId },
    );
    return response.data; // { message: "Like updated successfully", likeCount }
  } catch (error) {
    console.error("Error liking the news:", error);
    return null;
  }
};

export const postComment = async (commentData) => {
  try {
      
      const response = await axios.post(`${News_API}/add-comment`, commentData,
          );
      return response.data;
  } catch (error) {
      console.error("Error posting comment:", error);
      return { success: false, message: "Failed to post comment" };
  }
};

// ✅ GET: Fetch Comments for News
export const getCommentsByNewsId = async (newsId) => {
  try {
      const response = await axios.get(`${News_API}/get-comments-by-newsid/${newsId}`);
      return response.data;
  } catch (error) {
      console.error("Error fetching comments:", error);
      return { success: false, comments: [] };
  }
};




